<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div class="sc-main-container"  v-if="!this.display_auto_cart_preloader">
		<v-container grid-list-md pa-0 class="sc-banner-section" v-if="!loading && is_auto_cart && has_products">
			<v-layout row wrap>
				<v-flex class="md9 xs12">
					<div class="sc-banner-text">
						<div class="sc-banner-title">Quick shop</div>
						<div class="sc-banner-items-info" v-if="get_total_required && get_total_courses">
							You have {{get_total_required}} required item{{get_total_required > 1 ? "s" : ""}} for your {{get_total_courses}} course{{get_total_courses > 1 ? "s" : ""}} in {{term_name}} in your cart.
						</div>
						<div class="sc-banner-required">
							Buy preselected items and get required materials as soon as possible.
						</div>
						<div class="sc-banner-savings" v-if="this.totals.totalSaving > 0">
							<span class="sc-banner-savings-req">You Pay: $<span>{{formatPrice(totals.totalCost)}}</span></span>
							<span class="sc-banner-savings-cost">${{formatPrice(list_price_cost)}} (All new items)</span>
							<span class="sc-banner-savings-profit">SAVE ${{formatPrice(this.totals.totalSaving)}}</span>
						</div>
						<div class="sc-banner-actions">
							<div class="sc-banner-left">
								<v-btn
										href="/checkout"
										v-on:click.stop.prevent="goCheckoutBanner()"
										class="go-checkout-btn ma-0 sc-banner-checkout-btn"
										color="#4185F4"
										block
										v-bind="[
													ADAattr('button-readonly', proceeding_to_checkout, 'Check out now'),
													ADAattr('link')
												]"

										:loading="proceeding_to_checkout"
										:dark="!proceeding_to_checkout"
								>Buy now
								</v-btn>
							</div>
							<div class="sc-banner-goback sc-banner-left">
								Or you can <a href="/institutional/index.php?action=my_courses" v-on:click.stop.prevent="goCoursesBanner()">choose your own materials</a>.
							</div>

						</div>
					</div>
				</v-flex>
				<v-flex d-flex class="md3 xs12">
					<svg width="236" height="255" role="img" aria-label="Quick Shop" viewBox="0 0 236 255" fill="none" xmlns="http://www.w3.org/2000/svg">
						<g clip-path="url(#clip0_190_396)">
							<path
									d="M158.847 130.477C158.847 130.477 150.1 115.593 141.436 87.7286C141.436 87.7286 133.596 63.2539 124.354 72.5973"
									stroke="#292424" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round"/>
							<path
									d="M138.465 106.994C138.465 106.994 125.345 65.7345 116.433 64.3288C109.419 63.1712 109.914 72.5146 109.914 72.5146"
									stroke="#292424" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round"/>
							<path
									d="M129.882 114.436C129.882 114.436 123.611 85.4961 110.161 72.6799C108.758 71.3569 106.695 70.8608 104.962 71.6877C102.157 73.0933 101.579 77.0622 102.817 82.1887"
									stroke="#292424" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round"/>
							<path
									d="M118.578 115.345C118.578 115.345 109.666 82.933 100.837 81.4447C92.0073 79.9563 102.982 101.124 103.807 112.038C105.458 132.379 116.185 168.843 132.936 183.395"
									stroke="#292424" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round"/>
							<path
									d="M172.956 170C172.956 170 170.481 168.594 170.894 142.879C171.059 135.024 167.015 122.456 164.622 115.015C161.239 104.431 158.846 98.3949 153.4 97.9814C153.4 97.9814 146.386 96.8239 149.852 111.128"
									stroke="#292424" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round"/>
							<path opacity="0.2"
							      d="M137.062 255L129.305 194.475C128.81 191.994 129.223 189.431 130.626 187.281C135.412 179.84 151.915 170.414 176.505 170.414C180.136 170.414 186.242 172.315 187.728 177.855L219.084 255"
							      fill="#4185F4"/>
							<path
									d="M137.062 255L129.305 194.475C128.81 191.994 129.223 189.431 130.626 187.281C135.412 179.84 151.915 170.414 176.505 170.414C180.136 170.414 186.242 172.315 187.728 177.855L219.084 255"
									stroke="#292424" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round"/>
							<path d="M63.4561 46.965L88.2113 64.3288" stroke="#4185F4" stroke-width="2.5" stroke-miterlimit="10"
							      stroke-linecap="round"/>
							<path d="M123.941 55.0681L141.27 32.6605" stroke="#4185F4" stroke-width="2.5" stroke-miterlimit="10"
							      stroke-linecap="round"/>
							<path d="M100.507 25.1362L104.385 54.2413" stroke="#4185F4" stroke-width="2.5" stroke-miterlimit="10"
							      stroke-linecap="round"/>
							<path d="M94.4004 128.492L102.817 107.656" stroke="#292424" stroke-width="2.5" stroke-miterlimit="10"
							      stroke-linecap="round"/>
							<path
									d="M60.4854 181.659C60.4854 181.659 65.7665 169.917 61.9707 156.936C58.1749 143.954 67.5818 123.697 66.1791 113.278C64.7763 102.86 73.9357 100.379 78.1441 111.707C82.3525 123.035 77.5665 137.009 77.5665 137.009C77.5665 137.009 94.7301 97.4855 99.5986 95.3357"
									stroke="#292424" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round"
									stroke-linejoin="round"/>
							<path
									d="M94.0703 194.475C94.0703 194.475 96.2983 182.899 106.695 174.3C112.719 169.339 117.588 161.318 117.588 161.318"
									stroke="#292424" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round"/>
							<path
									d="M9.24219 255C9.24219 255 34.6576 200.593 50.5834 184.635C53.1415 182.072 56.9373 181.245 60.3205 182.568L95.7205 195.136C99.7639 196.707 102.239 200.924 101.497 205.224C99.5988 216.221 93.7401 248.633 91.017 256.158"
									stroke="#292424" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round"/>
							<path opacity="0.2"
							      d="M9.32422 254.752C9.32422 254.752 34.7396 200.345 50.6655 184.387C53.2235 181.824 57.0193 180.997 60.4025 182.32L95.8025 194.888C99.8459 196.459 102.321 200.676 101.579 204.976C99.6809 215.973 93.8221 248.385 91.099 255.909"
							      fill="#4185F4"/>
						</g>
						<defs>
							<clipPath id="clip0_190_396">
								<rect width="236" height="255" rx="12" fill="white"/>
							</clipPath>
						</defs>
					</svg>
				</v-flex>
			</v-layout>
		</v-container>
		<div class="section-title">
			<div class="sc-continue-shopping-block sc-continue-shopping-line">
				<button @click="goBack" v-bind="ADAattr('label', 'Continue shopping from homepage')">&larr; Continue shopping</button>
			</div>
			<div class="sc-continue-shopping-line sc-content-header">
				<h1 v-bind="[
					ADAattr('h1'),
					ADAattr('label', 'Your shopping cart contents')
				]" aria-level="1">
					Shopping Cart
				</h1>
				<div v-if="has_products && refresh_shopping_cart_timer === null && (!is_auto_cart || hold_left > 0)" tabindex="0" role="heading" aria-level="2"
					v-bind="[
						ADAattr('label', ada_hold_timer)
					]"
				>
					<div v-bind="ADAattr('sr-only', false)">{{ ada_hold_timer }}</div>
					<div v-if="hold_left > 0" class="sc-content-header-right" v-bind="ADAattr('hidden')">
						Holding your items for: <v-icon size="22px">schedule</v-icon> {{ hold_timer }}
					</div>
				</div>
			</div>
		</div>

		<v-container grid-list-md v-if="loading" pa-0>
			<v-progress-linear :indeterminate="true" v-bind="ADAattr('progress', 'Loading your shopping cart')"></v-progress-linear>
		</v-container>

		<v-container grid-list-md pa-0 v-else>
			<v-layout row wrap v-if="has_products">
				<v-flex class="md9 xs12">
					<v-layout row wrap>
						<v-flex mb2 pb-4 d-flex xs12 class="sc-section py-0">
							<v-card flat>
								<cart-book-list
										:products="products"
										:replacements="replacements"
										:free_shipping_margin="discounted_shipping_lvl1"
										:is_international_shipping="is_international_shipping"
										:is_auto_cart="is_auto_cart"
										@add-to-cart="onAddToCart"
										@replace-condition="onReplaceCondition"
										@changed-quantity="onChangedQuantity"
										@removed-item="onRemovedItem"
								></cart-book-list>

								<div class="sc-supplements" v-if="has_type['used'] || has_type['rental'] || has_type['exchange']">
									<div>
										<v-icon color="#767676" size="30">error_outline</v-icon>
									</div>
									<div class="px-1 pt-1">Supplements like Access Codes and CD-ROM-s are not guaranteed on purchases of used, rental or marketplace items.</div>
								</div>

								<div v-if="!this.$globs['is_vie']">


									<div class="sc-free-shipping sc-free-shipping-not-qualifying" v-if="enabled_retail_shipping_campus_only">
										<div>
											<v-icon color="#2170f2" size="40px">local_shipping</v-icon>
											<span>Free Economy Shipping</span>
										</div>
										<div class="sc-free-shipping-add" v-if="has_free_retail_shipping_campus_only">Free shipping when shipping to campus or</div>
										<div class="sc-free-shipping-add" v-else-if="discounted_shipping_lvl1_campus_only > 0">
											Add an additional <strong>${{ add_for_free_shipping_campus_only }}</strong> in retail items to qualify for Free Economy Shipping when shipping to campus or
										</div>
										<div v-if="has_free_retail_shipping">The retail items on your order qualify for Free Economy Shipping.</div>
										<div class="sc-free-shipping-add" v-else>Add an additional <strong>${{ add_for_free_shipping }}</strong> in retail items to qualify
											for Free Economy Shipping
										</div>
									</div>

									<div class="sc-free-shipping" v-else-if="has_free_retail_shipping">
										<div>
											<v-icon color="#2170f2" size="40px">local_shipping</v-icon>
											<span>Free Economy Shipping</span></div>
										<div>The retail items on your order qualify for Free Economy Shipping.</div>
									</div>
									<div class="sc-free-shipping sc-free-shipping-not-qualifying" v-else>
										<div>
											<v-icon color="#2170f2" size="40px">local_shipping</v-icon>
											<span>Free Economy Shipping</span>
										</div>
										<div class="sc-free-shipping-add">Add an additional <strong>${{ add_for_free_shipping }}</strong> in retail items to qualify
											for Free Economy Shipping
										</div>
									</div>
								</div>

								<div class="sc-info-line">
									<div>
										Time-to-ship excludes weekends and holidays. <br>
										Shipping charges and tax, if applicable, will be calculated during checkout.
									</div>
								</div>

								<div class="sc-info-line">
									<div><a href="/service/shipping.php">Learn more about shipping options and offers</a></div>
								</div>

							</v-card>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex d-flex class="md3 xs12">
					<v-card flat>
						<div class="co-totals-container">
							<div class="order-summary-container">
								<div class="os-charges">
									<div class="osc-line sc-subtotal" tabindex="0" role="heading" aria-level="2">
										<div class="oscl-name">Subtotal</div>
										<div class="oscl-value">{{ `$${formatPrice(subtotal)}` }}</div>
									</div>
									<div class="osc-line sc-go-checkout">
										<v-btn
												href="/checkout"
												v-on:click.stop.prevent="goCheckout(false)"
												class="go-checkout-btn ma-0"
												color="#2170f2"
												block
												v-bind="[
													ADAattr('button-readonly', proceeding_to_checkout, 'Check out now'),
													ADAattr('button')
												]"

												:loading="proceeding_to_checkout"
												:dark="!proceeding_to_checkout"
										>Check Out</v-btn>
									</div>
									<div class="osc-line osc-line-instruction">
										Shipping Charges and tax, if applicable, will be calculated during checkout.
									</div>
								</div>
							</div>
						</div>
						<div class="sc-accepted-payment-types">
							<div class="heading" aria-level="3" role="heading" tabindex="0">We accept</div>
							<div>
								<img src="/checkout/assets/cc_visa.png" height="40px" alt="Accepting Visa" tabindex="0" v-bind="ADAattr('img', 'Accepting Visa')">
								<img src="/checkout/assets/cc_mc.png" height="40px" alt="Accepting MasterCard" tabindex="0" v-bind="ADAattr('img', 'Accepting MasterCard')">
								<img src="/checkout/assets/cc_amex.png" height="40px" alt="Accepting American Express" tabindex="0" v-bind="ADAattr('img', 'Accepting American Express')">
								<img src="/checkout/assets/cc_discover.png" height="40px" alt="Accepting Discover" tabindex="0" v-bind="ADAattr('img', 'Accepting Discover')">
								<template v-if="has_third_party_payments_enabled">
									<img v-if="enabledThirdPaymentMethods.apple_pay" src="/img/apple_pay_mark.png" height="40px" alt="Accepting ApplePay" tabindex="0" v-bind="ADAattr('img', 'Accepting ApplePay')">
									<img v-if="enabledThirdPaymentMethods.google_pay" src="/img/google_pay_mark.png" height="40px" alt="Accepting GooglePay" tabindex="0" v-bind="ADAattr('img', 'Accepting GooglePay')">
									<img v-if="enabledThirdPaymentMethods.paypal" src="https://www.paypalobjects.com/webstatic/mktg/logo/pp_cc_mark_37x23.jpg" height="40px" alt="Accepting PayPal" tabindex="0" v-bind="ADAattr('img', 'Accepting PayPal')">
								</template>
							</div>
						</div>
					</v-card>

				</v-flex>
			</v-layout>
			<v-layout row wrap v-else>
				<v-flex xs12>
					<v-card>
						<v-card-title>
							<div class="sc-empty-msg" v-bind="ADAattr('focus')">
								Your shopping cart is empty
							</div>
						</v-card-title>
					</v-card>
				</v-flex>
			</v-layout>

			<v-layout row wrap>
				<v-flex xs12 v-if="sections_recommended.length > 0 || sections_recommended_loading">
					<required-books-block
							:items="sections_recommended"
							:title="recommendations.title"
							:limit="section_limit"
							:loading="sections_recommended_loading"
							@load-more="loadMoreRecommended"
					></required-books-block>
				</v-flex>
				<v-flex xs12 v-if="sections_featured.length > 0 || sections_featured_loading">
					<required-books-block
							:items="sections_featured"
							:title="featured.title"
							:limit="section_limit"
							:loading="sections_featured_loading"
							@load-more="loadMoreFeatured"
					></required-books-block>
				</v-flex>
			</v-layout>
		</v-container>

		<template>
			<div class="text-xs-center">
				<v-dialog
						v-model="show_replacements_dialog"
						persistent
						content-class="sc-replacement-dialog"
				>
					<v-card v-bind="ADAattr('dialog', !show_replacements_dialog, 'ada-rpd')">
						<v-card-title
								class="headline grey lighten-2"
								primary-title
								v-bind="ADAattr('h2')"
								id="ada-rpd"
						>
							Items in your cart have changed since you added them.
						</v-card-title>

						<v-card-text>
							<div v-bind="ADAattr('focus')">
								<v-icon>info</v-icon>
								The items below were removed from your cart because price or availability has changed.
							</div>

							<div class="co-products-sections">
								<div class="co-products co-products-brief">
									<div class="co-products-list-container">
										<ul class="co-products-list">
											<template v-for="(item, item_idx) in products">
												<li v-if="item.replacement">
													<div class="copl-cover">
														<v-img
																:src="item.cover"
																height="100px"
																contain
																position="center center"
																v-bind="ADAattr('hidden')"
														></v-img>
													</div>
													<div class="copl-info">
														<div class="mb-2" v-bind="[
															ADAattr('focus'),
															ADAattr('label', ADAitemLabel(item.title, item.isbn))
														]">
															{{ item.title }}
														</div>
														<div>
															Condition: {{ item.condition_text + (item.condition_additional ? ' - ' + item.condition_additional :
															'') }}
														</div>
														<div v-if="item.additional">Additional: {{ item.additional }}</div>
														<div v-bind="ADAattr('hidden')">ISBN: {{ item.isbn }}</div>
														<div
															v-if="item.replacement && item.replacement.error_message"
															class="co-text-highlight"
															v-bind="[
																ADAattr('focus'),
																ADAattr('label', `Reason: ${item.replacement.error_message}`)
															]"
														>
															<div v-bind="ADAattr('hidden')">
																{{ item.replacement.error_message }}
															</div>
														</div>
													</div>
												</li>
											</template>
										</ul>
									</div>
								</div>
							</div>
						</v-card-text>

						<v-divider v-bind="ADAattr('hidden')"></v-divider>

						<v-card-actions class="py-3 sc-replacement-dialog-buttons-panel">
							<v-spacer></v-spacer>
							<v-btn
									color="primary"
									@click="show_replacements_dialog = false; ADAfocus('#ada-replacement')"
									v-if="has_replacements"
							>
								Select alternative items
							</v-btn>

							<v-btn
									color="primary"
									flat
									@click="goCheckout(true)"
							>
								Checkout without these items
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</div>
		</template>


		<v-snackbar
				v-model="notice.shown"
				bottom
				:timeout="notice.timeout"
				:color="notice.color"
				dark
				multi-line
				auto-height
		>
			<span
				v-html="notice.text"
				class="message-box-content"
				v-bind="[
					ADAattr('alert', notice.severity),
					ADAfocus('notice.shown', ADAquerySelector('alert'))
				]"
			></span>
			<v-btn
					flat
					@click="notice.shown = false"
					v-bind="ADAattr('label', 'Return')"
			>
				Close
			</v-btn>
		</v-snackbar>
	</div>
	<div class="sc-auto-cart-preloader" v-else>
		<v-flex class="sc-auto-cart-block">
			<div class="sc-auto-cart-bg">

			</div>
			<div class="sc-auto-cart-loader-content">
				<v-img src="/checkout/assets/auto_cart_preloader.gif" class="sc-auto-cart-loader" contain position="center" ></v-img>
				<div class="sc-auto-cart-text">Hang tight, we're adding all of your required course materials to your cart for you...</div>
			</div>
		</v-flex>
	</div>
</template>

<script>
	import CartBookList from './CartBookList';
	import OrderSummary from './OrderSummary';
	import RequiredBooksBlock from './../../common/components/vuejs/RequiredBooksBlock';
	import Axios from 'axios';
	import _ from 'lodash';
	import {EventBus} from "./../includes/EventBus";
	import {formatPrice} from "./../includes/Miscellaneous";
	import {parseErrorResponse} from "../includes/Miscellaneous";

	export default {
		name: "CartMain",

		components: {
			CartBookList,
			OrderSummary,
			RequiredBooksBlock,
		},

		async mounted() {
			const self = this;

			this.display_auto_cart_preloader = this.$globs['display_auto_cart_preloader'] ?? false;

			if (this.display_auto_cart_preloader) {
				this.hideAutoCartPreloaderTimer();
			}

			EventBus.$on('show-message', ({msg, severity = 0, timeout = 6000}) => {
				self.notice.shown = true;
				self.notice.text = msg;
				self.notice.severity = severity;
				self.notice.timeout = timeout;
				self.notice.color = ['success', 'info', 'error'][Math.min(severity, 2)];
			});

			self.products = [];
			if (self.$globs.result.error_message && self.$globs.result.error_message.length) {
				EventBus.$emit('show-message', {
					msg: self.$globs.result.error_message,
					severity: 2,
					timeout: 3600000,
				});
			}

			self.loading = true;
			await self.fetchProducts();
			self.fetchRecommendations();

			self.fetchThirdPartyPaymentMethods();
		},

		data() {
			return {
				loading: true,
				products: [],
				replacements: null,
				has_replacements: false,
				show_replacements_dialog: false,

				customer_token: null,

				subtotal: 0,

				total_free_shipping: 0,
				discounted_shipping_lvl1: 0,
				discounted_shipping_lvl1_campus_only: 0,
				has_free_retail_shipping: false,
				enabled_retail_shipping_campus_only: false,
				has_free_retail_shipping_campus_only: false,
				free_shipping_campus_only_min: null,
				is_international_shipping: false,
				rental_exists: false,

				has_type: {},

				notice: {
					shown: false,
					text: '',
					color: 'error',
				},

				section_limit: 5,
				recommendations: {
					title: 'Other materials for your courses',
					title_has_required: 'Other materials for your courses',
					title_recommended_only: 'You may also like',
					sections: [],
				},

				featured: {
					title: 'School supplies',
					section: {},
				},

				enabledThirdPaymentMethods: {
					paypal: false,
					apple_pay: false,
					google_pay: false,
				},

				sections_recommended_loading: false,
				sections_featured_loading: false,

				refresh_shopping_cart_timer: null,
				user_hold_timer: null,
				hold_left: 0,

				proceeding_to_checkout: false,
				is_auto_cart: false,
				display_auto_cart_preloader: false,
				auto_cart_preloader_timer: null,
				term_name: '',
				totals: {
					totalCost: 0,
					totalSaving: 0
				},
			};
		},

		computed: {
			has_third_party_payments_enabled() {
				return _.filter(this.enabledThirdPaymentMethods, x => x).length > 0;
			},

			has_products() {
				return this.products.length > 0;
			},

			add_for_free_shipping() {
				return this.has_free_retail_shipping ? 0 : formatPrice(this.discounted_shipping_lvl1 - this.total_free_shipping);
			},

			add_for_free_shipping_campus_only() {
				return this.has_free_retail_shipping_campus_only? 0 : formatPrice(this.discounted_shipping_lvl1_campus_only - this.total_free_shipping);
			},


			sections_recommended() {
				const items = [];
				_.forEach(this.recommendations.sections, sec => {
					_.forEach(sec['books'], book => {
						book.type = sec['type'];
						book.ga_action = sec.ga_action;
						items.push(book);
					});
				});

				if (_.get(this.recommendations.sections, 'required.books', []).length) {
					this.recommendations.title = this.recommendations.title_has_required;
				} else {
					this.recommendations.title = this.recommendations.title_recommended_only;
				}

				return items;
			},

			sections_featured() {
				const items = [],
					ga_action = this.featured.section.ga_action;
				_.forEach(this.featured.section['books'], book => {
					book.type = 'featured';
					book.ga_action = ga_action;
					items.push(book);
				});

				return items;
			},

			hold_timer() {
				let date = new Date(null);
				date.setSeconds(this.hold_left);
				return date.toISOString().substr(14, 5);
			},
			list_price_cost() {
				return this.totals.totalCost + this.totals.totalSaving;
			},
			get_total_required() {
				return this.products.filter(obj => obj.is_required).length;
			},
			get_total_courses() {
				return [...new Set(this.products.filter(obj => obj.is_required && obj.course_id).map(obj => obj.course_id))].length;
			},
		},

		methods: {
			formatPrice,

			initHoldTimer(hold_left) {
				const self = this;
				self.hold_left = hold_left;

				if (self.user_hold_timer !== null) {
					window.clearInterval(self.user_hold_timer);
				}

				self.user_hold_timer = window.setInterval(() => {
					self.hold_left--;
					if (self.hold_left < 0) {
						self.hold_left = 0;
						window.clearInterval(self.user_hold_timer);
					}
				}, 1000);
			},

			fetchThirdPartyPaymentMethods() {
				Axios.get('/sc/rest.php/get_enabled_third_party_payments').then(({data}) => {
					this.enabledThirdPaymentMethods = data;
				});
			},

			prepareBook(book) {
				const item = book;
				if (!item.cover) item.cover = '/img/no_image.gif';
				item.replacement = null;
				item.product_type = item.product_id + '|' + (item.rental_term_id ? "rental" + item.rental_term_id : item.order_type);
				return item;
			},

			updateCart(data) {
				const self = this;

				self.products = _.map(data['cart_content'], item => {
					return self.prepareBook(item);
				});

				self.has_type = {};
				_.forEach(self.products, product => {
					self.has_type[product['condition']] = true;
				});

				self.subtotal = parseFloat(data.subtotal);
				self.total_free_shipping = parseFloat(data.total_free_shipping);
				self.discounted_shipping_lvl1 = parseFloat(data.discounted_shipping_lvl1);
				self.discounted_shipping_lvl1_campus_only = parseFloat(data.discounted_shipping_lvl1_campus_only);

				self.has_free_retail_shipping = data.has_free_retail_shipping;
				self.is_international_shipping = data.is_international_shipping;
				self.enabled_retail_shipping_campus_only = data.enabled_retail_shipping_campus_only;
				self.has_free_retail_shipping_campus_only = data.has_free_retail_shipping_campus_only;
				self.rental_exists = data.rental_exists;
				self.is_auto_cart = data.is_auto_cart;
				if(self.is_auto_cart) {
					self.term_name = data.term_name;
				}
			},

			async fetchProducts() {
				const self = this;

				return new Promise((resolve, reject) => {
					Axios.get('/sc/rest.php/get_all' + self.getTokenReq()).then(({data}) => {
						self.updateCart(data);
						self.loading = false;

						let qty_total = 0;
						const product_ids = _.map(self.products, item => {
							qty_total += parseInt(item.quantity, 10);
							return item.product_id;
						});
						if (typeof sendFBPixelAction === 'function') {
							sendFBPixelAction('InitiateCheckout', {
								value: self.subtotal,
								content_ids: product_ids,
								num_items: qty_total,
								currency: 'USD',
							});
						}

						self.initHoldTimer(parseInt(data['cart_hold_expiration']));
						if(self.is_auto_cart) {
							self.fetchTotals();
						}
						resolve();
					}).catch(err => {
						reject();
					});
				});
			},

			async fetchTotals() {
				const self = this;
				return new Promise((resolve, reject) => {
					Axios.get('/sc/rest.php/get_totals' + self.getTokenReq()).then(({data}) => {
						self.totals = data;
						resolve();
					}).catch(err => {
						reject();
					});
				});
			},

			getTokenReq() {
				return this.customer_token ? '?customer_token=' + this.customer_token : '';
			},

			onChangedQuantity(payload) {
				const self = this;

				payload.quantity = parseInt(payload.quantity) || 0;
				if (payload.quantity < 1) {
					payload.quantity = 1;
					return EventBus.$emit('show-message', {
						msg: 'Invalid quantity value',
						severity: 2,
					});
				}

				Axios.post(`/sc/rest.php/update/${payload.id}/${payload.quantity}`, {}).then(({data}) => {
					self.updateCart(data);

					if (data['reached_quantity_limit']) {
						EventBus.$emit('show-message', {
							msg: "Not enough items in stock",
							severity: 1,
						});
					}

				}).catch(error => {
					this.fetchProducts();
					EventBus.$emit('show-message', {
						msg: parseErrorResponse(error.response),
						severity: 2,
						timeout: 15000,
					});
				});
			},

			onRemovedItem(payload) {
				const self = this;

				Axios.post(`/sc/rest.php/delete/${payload.id}`, {}).then(({data}) => {
					self.updateCart(data);
					if(self.is_auto_cart) {
						self.fetchTotals();
					}
				});
			},

			fetchRecommendations() {
				const self = this;

				if (self.$globs['required_books_enabled']) {
					self.sections_recommended_loading = true;

					if (typeof sendGAAction === 'function') {
						sendGAAction('Checkout: loading required books block');
					}

					Axios.get(`/tools/ajax/misc_ajax.php/requiredBooks?json=true&referrer=checkout&limit=${self.section_limit}`).then(({data}) => {

						if (data.recommendations.recommended.books.length > 0) {
							if (typeof sendGAAction === 'function') {
								sendGAAction('Checkout: recommended books successfully loaded');
							}
						}
						if (data.recommendations.required.books.length > 0) {
							if (typeof sendGAAction === 'function') {
								sendGAAction('Checkout: required books successfully loaded');
							}
						}
						if (data.recommendations.required.books.length === 0 && data.recommendations.recommended.books.length === 0) {
							if (typeof sendGAAction === 'function') {
								sendGAAction('Checkout: required books list empty');
							}
						}

						self.recommendations.sections = data.recommendations;
						self.sections_recommended_loading = false;
					});
				}

				if (self.$globs['merchandise_enabled']) {
					self.sections_featured_loading = true;

					if (typeof sendGAAction === 'function') {
						sendGAAction('Checkout: loading featured books block');
					}

					Axios.get(`/tools/ajax/misc_ajax.php/featuredBooks?json=true&referrer=checkout&limit=${self.section_limit}`).then(({data}) => {

						if (data.section.books.length > 0) {
							if (typeof sendGAAction === 'function') {
								sendGAAction('Checkout: featured books successfully loaded');
							}
						}

						self.featured.section = data.section;
						self.sections_featured_loading = false;
					});
				}
			},

			loadMoreRecommended(offset) {
				if (!this.$globs.required_books_enabled) {
					return;
				}

				const limit = offset < 0 ? this.section_limit * 10 : this.section_limit + offset;
				this.sections_recommended_loading = true;

				Axios.get('/tools/ajax/misc_ajax.php/requiredBooks?json=true&referrer=checkout&limit=' +
					limit
				).then(({data}) => {
					let books = [];
					_.each(data.recommendations, group => {
						books = _.concat(books, group.books);
					});
					if (offset >= books.length) {
						offset %= books.length;
					}
					books = _.slice(_.slice(books, offset), 0, this.section_limit);
					if (books.length) {
						_.each(data.recommendations, group => {
							group.books = _.filter(group.books, book => _.includes(books, book));
						});
						this.recommendations.sections = data.recommendations;
					}
				}).finally(() => {
					this.sections_recommended_loading = false;
				});
			},

			loadMoreFeatured(offset) {
				if (!this.$globs.merchandise_enabled) {
					return;
				}

				const limit = offset < 0 ? this.section_limit * 10 : this.section_limit + offset;
				this.sections_featured_loading = true;

				Axios.get('/tools/ajax/misc_ajax.php/featuredBooks?json=true&referrer=checkout&limit=' +
					limit
				).then(({data}) => {
					let books = data.section.books;
					if (offset >= books.length) {
						offset %= books.length;
					}
					books = _.slice(_.slice(books, offset), 0, this.section_limit);
					if (books.length) {
						data.section.books = books;
						this.featured.section = data.section;
					}
				}).finally(() => {
					this.sections_featured_loading = false;
				});
			},

			goCheckoutBanner() {
				const self = this;
				self.proceeding_to_checkout = true;
				Axios.get(`/sc/rest.php/accept_autocart/`).then(({data}) => {
					this.goCheckout();
				});
			},

			goCoursesBanner() {
				const self = this;
				self.proceeding_to_checkout = true;
				Axios.get(`/sc/rest.php/cancel_autocart/`).then(({data}) => {
					document.location.href = '/institutional/index.php?action=my_courses';
					return;
				}).finally(() => {
					self.proceeding_to_checkout = false;
				});
			},

			goCheckout(force = false) {
				const self = this;
				self.proceeding_to_checkout = true;

				if (force || (_.isArray(self.replacements) && self.replacements.length > 0)) {
					document.location.href = '/sc/?action=remove_unavailable_items';
					return;
				}

				Axios.get(`/sc/rest.php/get_unavailable_lines/`).then(({data}) => {
					if (!data || data.length === 0) {
						document.location.href = '/checkout';
						return;
					}

					self.has_replacements = false;

					self.replacements = _.filter(_.map(data, product => {
						if (product === null) return null;

						if (!_.isEmpty(product.books)) {
							self.has_replacements = true;
						}

						return product;
					}));

					self.show_replacements_dialog = true;
					self.proceeding_to_checkout = false;
				});

			},

			onAddToCart(payload) {
				const self = this;
				let request = {
					product_id: payload.product_id,
					order_type: payload.order_type,
					quantity: payload.quantity,
					course_id: payload.course_id,
					replaced_cart_line_id: payload.cart_line_id,
				};
				if (payload.is_alibris) {
					request.partner = 'alibris';
				}

				Axios.post('/sc/rest.php/replace', request).then(({data}) => {
					if (!data.new_product) return;

					_.forEach(self.products, (product, idx) => {
						let rep_id = _.findIndex(self.replacements, (item) => item.cart_line_id === payload.cart_line_id);

						if (rep_id >= 0) {
							self.replacements.splice(rep_id, 1);

							let orig_id = _.findIndex(self.products, (item) => item.cart_line_id === payload.cart_line_id);
							self.products.splice(orig_id, 1, self.prepareBook(data.new_product));
						}
					});

					self.subtotal = parseFloat(data.subtotal);
				});
			},

			onReplaceCondition(payload) {
				const self = this;
				let request = {
					product_id: payload.product_id,
					order_type: payload.order_type,
					quantity: payload.quantity,
					course_id: payload.course_id,
					replaced_cart_line_id: payload.cart_line_id,
					replace_condition: 1
				};

				if (payload.is_alibris) {
					request.partner = 'alibris';
				}

				if (payload.rental_term_id) {
					request.order_type = "rental" + payload.rental_term_id;
				}

				Axios.post('/sc/rest.php/replace', request).then(({data}) => {
					if (!data.new_product || data.new_product.length === 0) {
						self.loading = true;
						this.fetchProducts();
						EventBus.$emit('show-message', {
							msg: data.error_message,
							severity: 2,
							timeout: 3600000,
						});
						return;
					}

					_.forEach(self.products, (product, idx) => {
						let orig_id = _.findIndex(self.products, (item) => item.cart_line_id === payload.cart_line_id);
						if (orig_id !== -1) {
							let new_book = self.prepareBook(data.new_product);
							new_book.variants = self.products[orig_id].variants;
							new_book.show_course_title = self.products[orig_id].show_course_title;
							new_book.show_syllabus_link = self.products[orig_id].show_syllabus_link;
							self.products.splice(orig_id, 1, new_book);
						}
					});

					self.subtotal = parseFloat(data.subtotal);
					if (self.is_auto_cart) {
						self.fetchTotals();
					}
				});
			},
			goBack() {
				if(this.$globs['is_tbx_referrer']) {
					window.history.go(-1)
				} else {
					window.location.href = '/';
				}
			},
			hideAutoCartPreloader() {
				this.display_auto_cart_preloader = false;
			},
			hideAutoCartPreloaderTimer() {
				this.auto_cart_preloader_timer = setTimeout(() => {
					if (!this.loading) {
						this.hideAutoCartPreloader();
					} else {
						this.auto_cart_preloader_timer = null;
					}
				}, 3000);
			},
		},
		watch: {
			loading(new_value) {
				if (this.display_auto_cart_preloader === true && !this.auto_cart_preloader_timer && new_value === false) {
					this.hideAutoCartPreloader();
				}
			}
		}
	};
</script>

<style scoped lang="less">
	@text_highlight_color: #2170f2;

	.sc-section {
		margin: 5px 0 10px;

		.sc-supplements {
			font-size: 15px;
			margin: 20px 0 10px;

			> :first-child {
				float: left;
			}

			> :last-child {
				margin-left: 35px;
			}
		}

		.sc-info-line {
			overflow: hidden;
			padding: 10px 0;
		}

		.sc-free-shipping {
			padding: 20px 0;

			> div {
				overflow: hidden;
				width: 100%;

				> i {
					display: block;
					float: left;
					margin-right: 10px;
				}

				> span {
					font-size: 20px;
					color: @text_highlight_color;
					float: left;
					display: block;
					height: 40px;
					line-height: 40px;
					vertical-align: middle;
				}

			}

			&.sc-free-shipping-not-qualifying {
				.sc-free-shipping-add {
					strong {
						color: @text_highlight_color;
					}
				}
			}
		}
	}

	.co-totals-container {
		border: 2px solid #DDDDDD;
		margin-left: 8px;
		padding: 15px 20px;
		font-size: 16px;

		.order-summary-container {
			.os-charges {
				overflow: hidden;
				margin: 10px 0;

				.osc-line {
					padding: 5px 0;
					overflow: hidden;

					&.sc-subtotal {
						display: flex;
						justify-content: space-between;
						font-size: 20px;
					}

					&.osc-line-instruction {
						font-size: 13px;
					}

					&.sc-go-checkout {
						padding: 10px 0;

						.go-checkout-btn {
							text-transform: capitalize;
							font-size: 16px;
							font-weight: normal;
							background-color: #2170F2 !important;
						}
					}

					.oscl-name {
						font-weight: bold;
					}
				}
			}

		}
	}

	.sc-accepted-payment-types {
		margin-left: 20px;
		margin-top: 16px;
		align-items: center;

		img {
			width: 62px;
		}

    .heading {
      font-weight: bold;
    }
	}

	.co-products-sections {
		.co-products {
			border-top: 1px solid #E0E0E0;

			&:first-child {
				border-top: none;
			}

			.co-products-list-container {
				width: 100%;
				margin-right: 5%;

				ul.co-products-list {
					list-style: none;
					padding-left: 0;

					> li {
						overflow: hidden;
						padding: 10px 0;

						border-top: 1px solid #E0E0E0;

						&:first-child {
							border-top: none;
						}

						h3 {
							color: #767676;
							font-size: 16px;
							font-weight: normal;
							margin-bottom: 10px;
							text-transform: uppercase;
						}

						.copl-cover {
							display: block;
							float: left;
							width: 15%;
						}

						.copl-info {
							display: block;
							box-sizing: border-box;
							float: left;
							width: 85%;
							padding: 10px;

							div {
								font-size: 14px;
							}
						}
					}
				}
			}
		}
	}


	/deep/ .sc-replacement-dialog {
		width: 600px;

		.v-card__actions .v-btn {
			margin-left: 0 !important;
		}

		@media screen and (max-width: 600px) {
			width: 300px;

			.sc-replacement-dialog-buttons-panel {
				flex-direction: column;

			}
		}
	}

	/deep/ .sc-empty-msg {
		font-size: 1.5em;
		flex: 1;
		text-align: center;
		font-weight: 600;
		color: @text_highlight_color;
	}

	.sc-main-container {
		@media screen and (max-width: 600px) {
			padding: 0.5em;
		}
	}

	.sc-content-header {
		margin-bottom: 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-wrap: wrap;

		@media screen and (max-width: 600px) {
			margin: 0 10px 10px;
			flex-direction: column;
		}

		.sc-content-header-right {
			display: block;
			font-size: 15px;
			color: #73777c;
			font-weight: normal;
		}
	}

	.sc-banner-section {
		box-sizing: border-box;
		position: relative;
		height: 256px;
		background: rgba(212, 228, 255, 0.25);
		border: 1px solid #4185F4;
		border-radius: 12px;
		@media screen and (max-width: 1120px) {
			height: 247px;
		}
		svg {
			@media screen and (max-width: 840px) {
				display: none;
			}
		}
	}

	.sc-banner-text {
		padding: 30px 30px 30px 30px;
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 600;
		font-size: 18px;
		line-height: 24px;
		color: #292424;

		div {
			margin: 10px 0 10px 0;
		}
	}

	.sc-banner-title {
		font-weight: 700;
		font-size: 32px;
		line-height: 20px;
		letter-spacing: 0.05em;

	}

	.sc-banner-required {
		font-weight: 400;
		font-size: 16px;
		line-height: 23px;
		letter-spacing: 0.05em;
	}

	.sc-banner-savings {
		span {
			margin-right: 20px;
		}
	}

	.sc-banner-savings-cost {
		text-decoration-line: line-through;
		color: #B00020;
		font-style: normal;
		font-weight: 600;
		font-size: 18px;
		line-height: 24px;
	}

	.sc-banner-savings-profit {
		padding: 4px 10px;
		background: rgba(98, 255, 113, 0.4);
		border-radius: 12px;
		font-size: 14px;
		line-height: 18px;
		letter-spacing: 0.05em;
	}

	.sc-banner-checkout-btn {
		width: 198px;
		background-color: #2170F2 !important;
		text-transform: capitalize !important;
	}

	.sc-banner-goback {
		font-weight: 400;
		font-size: 14px;
		line-height: 18px;
		margin: 18px 20px 16px 20px !important;

		a {
			text-decoration: underline;
		}

		a, a:visited, a:hover, a:active {
			color: inherit !important;
			font-weight: bold;
		}
	}

	.sc-banner-left {
		float: left;
	}

	/deep/ .message-box-content {
		a {
			color: #b5e5ea !important;
		}
	}

	.sc-auto-cart-preloader {
		margin-top: -3.75em;
	}
	.sc-auto-cart-block {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 40px;
	}

	.sc-auto-cart-loader-content {
		margin-top: -735px;
		display: flex;
		flex-direction: column;
		align-items: center;
		@media screen and (max-width: 1394px) {
			margin-top: 0;
		}
	}
	.sc-auto-cart-loader {
		width: 150px;
		height: 150px;
	}

	.sc-auto-cart-text {
		color: rgba(0, 0, 0, 0.70);
		text-align: center;
		font-feature-settings: 'clig' off, 'liga' off;
		font-family: 'Roboto';
		font-size: 32px;
		font-style: normal;
		font-weight: 500;
		line-height: 120%; /* 38.4px */
		letter-spacing: 1.25px;
		width: 546px;
	}

	.sc-auto-cart-bg {
		background-image: url('/checkout/assets/auto_cart_background.svg');
		width: 1394px;
		height: 1024px;
		@media screen and (max-width: 1394px) {
			display: none;
		}

	}



</style>
